import type { TemplateFormLanguage } from '../types/templateForms';
import { DEFAULT_TEMPLATE_FORM_LANGUAGE } from './constants';

export interface IntakeStatusMessage {
    title: string;
    message: string;
}

export interface IntakeStatusTranslations {
    statuses: {
        IntakeCompleted: IntakeStatusMessage;
        Expired: IntakeStatusMessage;
        Terminated: IntakeStatusMessage;
        NewManualQuoteSent: IntakeStatusMessage;
        Forbidden: IntakeStatusMessage;
        Restarted: IntakeStatusMessage;
    };
    fallbacks: {
        failedTitle: string;
        somethingWentWrong: string;
    };
}

const ENGLISH_TRANSLATIONS: IntakeStatusTranslations = {
    statuses: {
        IntakeCompleted: {
            title: 'Intake Completed',
            message: 'Intake is already completed!',
        },
        Expired: {
            title: 'Intake Expired',
            message: 'The intake form has not been completed before its expiry date.',
        },
        Terminated: {
            title: 'Terminated',
            message:
                'The intake link has been expired. Please contact your law firm for more info or an updated link.',
        },
        NewManualQuoteSent: {
            title: 'New Manual Quote Sent',
            message:
                'A new version of the quote has been sent to you and this quote is no longer valid. Please contact us if you have questions',
        },
        Forbidden: {
            title: 'Intake Completed',
            message: 'Intake is already completed!',
        },
        Restarted: {
            title: 'New Link Sent',
            message:
                'This form link has expired. A new link has been sent to your email. Please check your inbox.',
        },
    },
    fallbacks: {
        failedTitle: 'Failed:',
        somethingWentWrong: 'Something went wrong!',
    },
};

const FRENCH_TRANSLATIONS: IntakeStatusTranslations = {
    statuses: {
        IntakeCompleted: {
            title: 'Admission terminée',
            message: 'L’admission est déjà terminée!',
        },
        Expired: {
            title: 'Admission expirée',
            message: 'Le formulaire d’admission n’a pas été rempli avant sa date d’expiration.',
        },
        Terminated: {
            title: 'Lien résilié',
            message:
                'Le lien d’admission a expiré. Veuillez communiquer avec votre cabinet pour plus d’information ou pour obtenir un lien mis à jour.',
        },
        NewManualQuoteSent: {
            title: 'Nouvelle soumission manuelle envoyée',
            message:
                'Une nouvelle version de la soumission vous a été envoyée et cette soumission n’est plus valide. Veuillez communiquer avec nous si vous avez des questions.',
        },
        Forbidden: {
            title: 'Admission terminée',
            message: 'L’admission est déjà terminée!',
        },
        Restarted: {
            title: 'Nouveau lien envoyé',
            message:
                'Ce lien de formulaire a expiré. Un nouveau lien a été envoyé à votre courriel. Veuillez vérifier votre boîte de réception.',
        },
    },
    fallbacks: {
        failedTitle: 'Échec :',
        somethingWentWrong: 'Une erreur s’est produite!',
    },
};

export const INTAKE_STATUS_TRANSLATIONS: Record<TemplateFormLanguage, IntakeStatusTranslations> = {
    en: ENGLISH_TRANSLATIONS,
    fr: FRENCH_TRANSLATIONS,
};

export function getIntakeStatusTranslations(
    language: TemplateFormLanguage = DEFAULT_TEMPLATE_FORM_LANGUAGE,
): IntakeStatusTranslations {
    return INTAKE_STATUS_TRANSLATIONS[language] ?? INTAKE_STATUS_TRANSLATIONS.en;
}
